import { createContext } from 'react';

export enum ApplicationPageHeaderType {
  PAGE_NAME,
  TEXT,
}
export const ApplicationPageContext = createContext({ headerType: ApplicationPageHeaderType.PAGE_NAME });
